import React, { useState } from 'react';
import MouseLightEffect from './MouseLightEffect';
import PorcentajeBateriaInput from './PorcentajeBateriaInput';
import { useTrack } from '../analytics/TrackingContext';

function Autonomia({ capacidadBateria }) {
  const { trackEvent } = useTrack();
  const [porcentajeBateria, setPorcentajeBateria] = useState('');
  const [consumo, setConsumo] = useState('');
  const [resultado, setResultado] = useState(null);
  const [animarResultado, setAnimarResultado] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showInfo, setShowInfo] = useState(false);

  const calcularKilometros = () => {
    if (!porcentajeBateria || !consumo || parseFloat(consumo) === 0) {
      setErrorMessage('Por favor, introduce todos los datos.');
      setResultado(null);
      return;
    }
    if (!capacidadBateria || parseFloat(capacidadBateria) <= 0) {
      setErrorMessage('Introduce la capacidad de la batería en el campo superior.');
      setResultado(null);
      return;
    }

    const kWhBateria = (parseFloat(porcentajeBateria) / 100) * parseFloat(capacidadBateria);
    const kmRecorridos = (kWhBateria * 100) / parseFloat(consumo);
    setResultado({ km: kmRecorridos, kWh: kWhBateria.toFixed(2) });
    setAnimarResultado(true);
    setErrorMessage('');
    trackEvent('calculation', 'autonomia');
  };

  return (
    <MouseLightEffect>
    <div className="section-container">

      <div className="tooltip-wrapper" style={{ position: 'absolute', top: '12px', right: '12px' }}>
        <button
          onClick={() => setShowInfo(true)}
          aria-label="Más información"
          style={{ background: 'transparent', border: '1px solid #ccc', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', fontSize: '1rem', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Kiafontl, Kiafontn, Arial, sans-serif' }}
        >ℹ</button>
        <span className="tooltip-text tooltip-left">Más información</span>
      </div>

      <h2 style={{ textAlign: 'center', width: '100%' }}>¿Cuántos Kilómetros recorreré?</h2>

      {showInfo ? (
        <div className="info-panel">
          <p>Calcula la autonomía estimada de tu vehículo eléctrico. Introduce el porcentaje de batería disponible y el consumo medio del vehículo en kWh por cada 100 km. El resultado te indicará cuántos kilómetros puedes recorrer.</p>
          <div className="button">
            <button className="calc" onClick={() => setShowInfo(false)}>← Volver</button>
          </div>
        </div>
      ) : (
        <>
          <PorcentajeBateriaInput
            id="pct_autonomia"
            label="% Batería:"
            value={porcentajeBateria}
            onChange={setPorcentajeBateria}
          />

      <div className="input">
        <label htmlFor="consumo_input">Consumo del VE (kWh/100 Km):</label>
        <input
          id="consumo_input"
          type="number"
          value={consumo}
          onChange={(e) => setConsumo(e.target.value)}
          placeholder="Ej: 15"
          min="0"
        />
      </div>

      <div className="button">
        <button className="calc" onClick={calcularKilometros}>Calcular Autonomía</button>
      </div>

      {errorMessage && (
          <div className="error-message" role="alert" aria-live="assertive">
          <p>{errorMessage}</p>
        </div>
      )}

      {resultado !== null && (
          <div className={`res ${animarResultado ? 'resultado-animado' : ''}`} aria-live="polite" aria-atomic="true">
          <p>Con el {porcentajeBateria}% de batería ({resultado.kWh} kWh):</p>
          <p><strong>{resultado.km.toFixed(2)} Km</strong></p>
          <div className="icon-container">
            <img
              src={`${process.env.PUBLIC_URL}/images/Autonomia01.png`}
              alt="Icono de Batería"
              className="autonomia"
            />
          </div>
        </div>
      )}
        </>
      )}
    </div>
    </MouseLightEffect>
  );
}

export default Autonomia;

